<template>
    <div id="saas">
        <navbar></navbar>
        <div id="sections-area">
            <hero></hero>
            <floating-images></floating-images>
            <about></about>
            <how-it-works></how-it-works>
            <start-now></start-now>
            <!--<comparison></comparison>-->
            <!-- <why-us></why-us> -->
            <why-choose-us></why-choose-us>
            <showcase></showcase>
            <partners></partners>
            <pricing></pricing>
        </div>
        <contact></contact>
      <div class="text-center my-2 footer-text">
        <a target="_blank" rel="nofollow" href="/docs/terms-of-use.pdf">Terms & Conditions</a>
        ·
        <a target="_blank" rel="nofollow" href="/docs/privacy-policy.pdf">Privacy Policy</a>
        ·
        <a target="_blank" href="/#contact">Contact Us</a>
        ·
        <a target="_blank" rel="nofollow" href="/join-the-team">Apply For a Job</a>
        ·
        <a target="_blank" href="https://www.facebook.com/spiritt.apps/" rel="noopener">Facebook</a>
        ·
        <a target="_blank" href="https://www.instagram.com/spiritt.io/" rel="noopener">Instagram</a>
      </div>
        <img class="background-fixed-img" src="/img/startup-bg.jpg" alt="SPIRITT background">
    </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import Navbar from './components/Navbar.vue';
  import Hero from './components/Hero.vue';
  import FloatingImages from './components/FloatingImages.vue';
  import About from './components/About.vue';
  import Partners from './components/Partners.vue';
  import Contact from './components/Contact.vue';
  import StartNow from "./components/StartNow.vue";
  import Showcase from "./components/Showcase.vue";
  import HowItWorks from "./components/HowItWorks.vue";
  import Pricing from "./components/Pricing.vue";
  import WhyChooseUs from './components/WhyChooseUs.vue';
  import localforage from "localforage";

  export default {
    name: 'saas',
    computed: {
      ...mapState('layout', {
        language: state => state.language,
        urlParams: state => state.urlParams,
      }),
      ...mapGetters({
        mobile: 'layout/mobile',
        modal: 'layout/modal',
        isScrolled: 'layout/isScrolled',
        isMvpModalOpen: 'layout/isMvpModalOpen',
      }),
    },
    components: {
      StartNow,
      'navbar': Navbar,
      'hero': Hero,
      'floating-images': FloatingImages,
      'about': About,
      'start-now': StartNow,
      //'why-us': WhyUs,
      'partners': Partners,
      'contact': Contact,
      'showcase': Showcase,
      'how-it-works': HowItWorks,
      'pricing': Pricing,
      //'comparison': Comparison,
      'why-choose-us': WhyChooseUs
    },
    methods: {
      ...mapActions({
        updateModalTitle: 'layout/updateModalTitle',
        updateModalVisibility: 'layout/updateModalVisibility',
        updateModalContent: 'layout/updateModalContent',
        updateIsScrolled: 'layout/updateIsScrolled',
        updateMvpModalVisibility: 'layout/updateMvpModalVisibility',
        setUrlParams: 'layout/setUrlParams',
      }),
      handleScroll () {
        return this.isScrolled && window.scrollY ? null : this.updateIsScrolled({
          payload: {
            scrolled: window.scrollY,
          },
        });
      },
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll);
      const urlParams = new URLSearchParams(window.location.search);
      const urlParamsAsJson = {
        utm_source: urlParams.get('utm_source'),
            utm_medium: urlParams.get('utm_medium'),
            utm_campaign: urlParams.get('utm_campaign'),
            utm_term: urlParams.get('utm_term'),
            utm_content: urlParams.get('utm_content'),
            fbclid: urlParams.get('fbclid'),
      }


      localforage.getItem('utm').then(data => {
        localforage.setItem('utm', {
          utm_source: urlParamsAsJson.utm_source ? urlParamsAsJson.utm_source : data ? data.utm_source : null,
          utm_medium: urlParamsAsJson.utm_medium ? urlParamsAsJson.utm_medium : data ? data.utm_medium : null,
          utm_campaign: urlParamsAsJson.utm_campaign ? urlParamsAsJson.utm_campaign : data ? data.utm_campaign : null,
          utm_term: urlParamsAsJson.utm_term ? urlParamsAsJson.utm_term : data ? data.utm_term : null,
          utm_content: urlParamsAsJson.utm_content ? urlParamsAsJson.utm_content : data ? data.utm_content : null,
          fbclid: urlParamsAsJson.fbclid ? urlParamsAsJson.fbclid : data ? data.fbclid : null,
        });
      });


      this.setUrlParams({
        payload: {
          urlParams: {
            ...urlParamsAsJson
          },
        },});



    },
  }
</script>
<style lang="css" scoped>
    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap');
    #saas {
        font-family: Josefin Sans, sans-serif;
        font-size: 1.125rem;
        position: relative;
        overflow: hidden;
        scroll-behavior: smooth;
        display: block;
    }
    .footer-text{
      font-size: 14px;
      color: #808080 !important;
    }
    .background-fixed-img{
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 1;
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        transition: opacity 1s;
        background-attachment: fixed;
        object-fit: cover;
        z-index: -1;
    }
    @media (max-width: 767px) and (min-width: 320px){
        .background-fixed-img {
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: 1;
            position: fixed;
            right: 0;
            top: 0;
            bottom: 0;
            transition: opacity 1s;
            z-index: -1;
        }
    }
</style>
